var React = require('react');

function Scythe (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M549.87 0L510 192H0C64 64 192 0 338.87 0z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M639.44 38l-96.27 461a16 16 0 0 1-15.72 13H496a16 16 0 0 1-16-16 16.16 16.16 0 0 1 .27-2.94l29.26-141H400a16 16 0 0 1-16-16V304a16 16 0 0 1 16-16h122.81L582.55 0H608a32 32 0 0 1 31.44 38z","className":"fa-primary","key":2})]);
}

Scythe.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Scythe;

Scythe.default = Scythe;
